// extracted by mini-css-extract-plugin
export default {"chartContainer":"HalfGaugeChart_chartContainer__Kr5OC","childrenContainer":"HalfGaugeChart_childrenContainer__5Zb0h"};